  import { AssetClassificationList } from "./list";

  export default function AssetClassificationLanding() {
    return (
      <div>
        <AssetClassificationList />
      </div>
    );
  }
